import type { AccessConstraint } from '@sb/shared/access';
import { PlanType } from '@shiftbase-com/ts-shared/models';

/** Access constraints for the employee-settings routes. */
const employeesBase = { permission: ['Manage account'] } satisfies AccessConstraint;

export const employeeSettingsAccess = {
  employees: { ...employeesBase, subscriptionPlan: PlanType.BASIC },
  notifications: { ...employeesBase, subscriptionPlan: PlanType.BASIC },
  'contract-types': { ...employeesBase, subscriptionPlan: PlanType.BASIC },
  'overtime-policies': { ...employeesBase, subscriptionPlan: PlanType.PREMIUM },
  surcharges: { ...employeesBase, subscriptionPlan: PlanType.BASIC },
  'holiday-groups': { ...employeesBase, subscriptionPlan: PlanType.BASIC },
  'holiday-group': { ...employeesBase, subscriptionPlan: PlanType.BASIC },
  skills: { ...employeesBase, subscriptionPlan: PlanType.PREMIUM },
  'custom-fields': { ...employeesBase, subscriptionPlan: PlanType.PREMIUM },
} satisfies Record<string, AccessConstraint>;
